import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { getTenantAdmins, getRegionNames, getTenantOrDomain } from "../components/Requests/Requests";
import {
  StandardScreen,
  StandardDropdown, 
  StandardTextField, 
  StandardButton, 
  StatusMessage, 
  PageLayout
} from '../components/Layout';

const inputTypeDropdownOptions = [
    { key: 'domain', text: 'Domain' },
    { key: 'tenantID', text: 'Tenant ID' }
];

class MobileActions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tenantId: "",
            error: "",
            message: "",
            warning: "",
            loading: false,
            loadingAdmin: false,
            loadingTenantDomain: false,
            tenantAdmins: [],
            regionNames: "",
            regionNameChosen: "",
            regionNameChosenDomain: "",
            queryValue: "",
            errorDomain: "",
            messageDomain: "",
            queryResults: [],
            inputTypeChosen: "",
            searchPerformed: false
        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.getRegionNames();
    }

    async getRegionNames() {
        this.setState({ loading: true })
        let response = await getRegionNames(this.props.accessToken);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                loading: false,
                regionNames: data.map(item =>
                    ({ key: item, text: item })),
            });
        } else {
            this.setState({ loading: false, error: "Something went wrong", message: "" });
        };
    }

    onSelectRegionName = (event, item) => {
        this.setState({ 
            regionNameChosen: item.key,
            error: "",
            message: "",
            tenantAdmins: []
        });
    };

    onSelectRegionNameDomain = (event, item) => {
        this.setState({ 
            regionNameChosenDomain: item.key, 
            errorDomain: "",
            messageDomain: "",
            queryResults: [],
            searchPerformed: false 
        });
    };

    onSelectInputType = (event, item) => {
        this.setState({ 
            inputTypeChosen: item.key, 
            errorDomain: "",
            messageDomain: "",
            queryResults: [],
            searchPerformed: false 
        });
    };

    onTenantIdChange = (event, newValue) => {
        this.setState({ 
            tenantId: newValue,
            error: "",
            message: "",
            tenantAdmins: []
        });
    };

    onQueryValueChange = (event, newValue) => {
        this.setState({ 
            queryValue: newValue,
            errorDomain: "",
            messageDomain: "",
            queryResults: [],
            searchPerformed: false
        });
    };

    async getTenantAdmins() {
        this.setState({ loadingAdmin: true, error: "", message: "", tenantAdmins: [] })
        let requestBody = {
            TenantId: this.state.tenantId,
            RegionName: this.state.regionNameChosen
        };
        let response = await getTenantAdmins(this.props.accessToken, requestBody);
        let data = await response.json();
        if (response.status === 200) {
            if(data.length === 0) {
                this.setState({ error: "No tenant admins found.", loadingAdmin: false});
            }
            else{
                // Check if data is an array, otherwise treat it as a single admin
                const admins = Array.isArray(data) ? data : [data];
                this.setState({ loadingAdmin: false, tenantAdmins: admins })
            }
        }
        else if (response.status === 500){
            this.setState({loadingAdmin: false, warning: data.message, tenantAdmins: [] });
        }
        else {
            this.setState({ loadingAdmin: false, error: "Something went wrong", tenantAdmins: [] });
        }
    }

    async getTenantOrDomain() {
        this.setState({ loadingTenantDomain: true, errorDomain: "", messageDomain: "", queryResults: [] })
        let requestBody = {
            QueryValue: this.state.queryValue,
            RegionName: this.state.regionNameChosenDomain,
            InputType: this.state.inputTypeChosen
        };
        let response = await getTenantOrDomain(this.props.accessToken, requestBody);
        let data = await response.json();
        if (response.status === 200) {
            // Check if data is an array, otherwise treat it as a single value
            const results = Array.isArray(data) ? data : [data];
            this.setState({ loadingTenantDomain: false, queryResults: results, searchPerformed: true})
        } else {
            this.setState({ loadingTenantDomain: false, errorDomain: "Something went wrong", queryResults: [], searchPerformed: true});
        }
    }

    render() {
        const {
            loading,
            loadingAdmin,
            loadingTenantDomain,
            error,
            message,
            warning,
            errorDomain,
            messageDomain,
            tenantId,
            regionNameChosen,
            regionNameChosenDomain,
            inputTypeChosen,
            queryValue,
            regionNames,
            tenantAdmins,
            searchPerformed,
            queryResults
        } = this.state;

        return (
            <PageLayout>
                <StandardScreen
                    title="Check Tenant Admins"
                    description="Check the admins of a given Mobile TenantID"
                    loading={loading}
                >
                    <StandardDropdown
                        label="Environment"
                        selectedKey={regionNameChosen}
                        onChange={this.onSelectRegionName}
                        placeholder="Select Environment"
                        options={regionNames}
                        disabled={!regionNames || regionNames.length === 0}
                    />

                    <StandardTextField
                        label="Tenant ID"
                        placeholder="Tenant ID"
                        value={tenantId}
                        onChange={this.onTenantIdChange}
                    />

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                        <StandardButton
                            text="Search"
                            onClick={() => this.getTenantAdmins()}
                            disabled={loadingAdmin || !tenantId || !regionNameChosen}
                            style={{ marginRight: '10px' }}
                        />
                        {loadingAdmin && (
                            <Spinner size={SpinnerSize.small} label="Loading..." />
                        )}
                    </div>

                    {error && (
                        <StatusMessage type="error">{error}</StatusMessage>
                    )}
                    
                    {warning && (
                        <StatusMessage type="warning">{warning}</StatusMessage>
                    )}

                    {message && (
                        <StatusMessage type="success">{message}</StatusMessage>
                    )}

                    {tenantAdmins.length > 0 && (
                        <div style={{ marginTop: '20px' }}>
                            <StatusMessage>
                                <strong>Tenant Admins:</strong>
                                <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                                    {tenantAdmins.map((admin, index) => (
                                        <li key={index} style={{ marginBottom: '5px' }}>
                                            {admin}
                                        </li>
                                    ))}
                                </ul>
                            </StatusMessage>
                        </div>
                    )}
                </StandardScreen>

                <StandardScreen
                    title="TenantID / Domain Lookup"
                    description="Check the TenantID associated with a Domain or vice versa."
                    loading={false}
                >
                    <StandardDropdown
                        label="Environment"
                        selectedKey={regionNameChosenDomain}
                        onChange={this.onSelectRegionNameDomain}
                        placeholder="Select Environment"
                        options={regionNames}
                        disabled={!regionNames || regionNames.length === 0}
                    />

                    <StandardDropdown
                        label="Input Type"
                        selectedKey={inputTypeChosen}
                        onChange={this.onSelectInputType}
                        placeholder="Select Input Type"
                        options={inputTypeDropdownOptions}
                    />

                    <StandardTextField
                        label="Tenant ID / Domain"
                        placeholder="Tenant ID / Domain"
                        value={queryValue}
                        onChange={this.onQueryValueChange}
                    />

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                        <StandardButton
                            text="Search"
                            onClick={() => this.getTenantOrDomain()}
                            disabled={loadingTenantDomain || !queryValue || !inputTypeChosen || !regionNameChosenDomain}
                            style={{ marginRight: '10px' }}
                        />
                        {loadingTenantDomain && (
                            <Spinner size={SpinnerSize.small} label="Loading..." />
                        )}
                    </div>

                    {errorDomain && (
                        <StatusMessage type="error">{errorDomain}</StatusMessage>
                    )}

                    {messageDomain && (
                        <StatusMessage type="success">{messageDomain}</StatusMessage>
                    )}

                    {searchPerformed && (
                        <div style={{ marginTop: '20px' }}>
                            {queryResults && queryResults.length > 0 ? (
                                <StatusMessage>
                                    <strong>Item(s) associated with input value:</strong>
                                    <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                                        {queryResults.map((result, index) => (
                                            <li key={index} style={{ marginBottom: '5px' }}>
                                                {result}
                                            </li>
                                        ))}
                                    </ul>
                                </StatusMessage>
                            ) : (
                                <StatusMessage type="warning">
                                    <strong>No results found.</strong>
                                </StatusMessage>
                            )}
                        </div>
                    )}
                </StandardScreen>
            </PageLayout>
        );
    }
}

export default MobileActions;
